/**
 * @generated SignedSource<<c870f3b83693c083585fbd339034ebe4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteClientTagInput = {
  clientId: string;
  clientMutationId?: string | null | undefined;
};
export type ClientSettingsDialogDeleteTagClientMutation$variables = {
  input: DeleteClientTagInput;
};
export type ClientSettingsDialogDeleteTagClientMutation$data = {
  readonly deleteClientTag: {
    readonly deleted: boolean | null | undefined;
  } | null | undefined;
};
export type ClientSettingsDialogDeleteTagClientMutation = {
  response: ClientSettingsDialogDeleteTagClientMutation$data;
  variables: ClientSettingsDialogDeleteTagClientMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteClientTagPayload",
    "kind": "LinkedField",
    "name": "deleteClientTag",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientSettingsDialogDeleteTagClientMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientSettingsDialogDeleteTagClientMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9cbadda59dd60b080809d76036a6b615",
    "id": null,
    "metadata": {},
    "name": "ClientSettingsDialogDeleteTagClientMutation",
    "operationKind": "mutation",
    "text": "mutation ClientSettingsDialogDeleteTagClientMutation(\n  $input: DeleteClientTagInput!\n) {\n  deleteClientTag(input: $input) {\n    deleted\n  }\n}\n"
  }
};
})();

(node as any).hash = "ff77d76f31fe2ba86a79578bc0232547";

export default node;
